export const DEVICE_ACTION = 'DEVICE_ACTION'
export const RESET_DEVICES_ACTION = 'RESET_DEVICES_ACTION'
export const ADD_USER = 'ADD_USER'
export const UPDATE_DEVICE = 'UPDATE_DEVICE'
// Mutations
export const SAVE_DEVICE = 'SAVE_DEVICE'
export const SAVE_NOTIF = 'SAVE_NOTIF'
export const RESET_DEVICES = 'RESET_DEVICES'
export const UPDATED_DEVICE = 'UPDATED_DEVICE'
export const SAVE_DEVICE_INFO_FONT_SIZE = 'SAVE_DEVICE_INFO_FONT_SIZE'



// WEBPACK FOOTER //
// ./src/store/actions/webView.js